import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import vcmLogo from "@/assets/vcm-logo-small.webp";

const Footer = () => {
  return (
    <footer className="bg-card border-t border-border py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <img 
                src={vcmLogo} 
                alt="Viral Check Media" 
                width="140" 
                height="98"
                className="h-8 w-auto brightness-110 contrast-125" 
              />
            </Link>
            <p className="text-muted-foreground text-sm">
              The Premier TikTok Live Creator Network
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Company</h3>
            <div className="space-y-2">
              <Link to="/why" className="block text-sm text-muted-foreground hover:text-primary transition-colors">
                Why VCM
              </Link>
              <Link to="/success" className="block text-sm text-muted-foreground hover:text-primary transition-colors">
                Success Stories
              </Link>
              <Link to="/program" className="block text-sm text-muted-foreground hover:text-primary transition-colors">
                The Program
              </Link>
            </div>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <div className="space-y-2">
              <Link to="/faq" className="block text-sm text-muted-foreground hover:text-primary transition-colors">
                FAQ
              </Link>
              <Link to="/contact" className="block text-sm text-muted-foreground hover:text-primary transition-colors">
                Contact
              </Link>
              <Link to="/apply" className="block text-sm text-muted-foreground hover:text-primary transition-colors">
                Apply Now
              </Link>
            </div>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Contact</h3>
            <div className="flex items-center space-x-2 text-sm text-muted-foreground">
              <Mail size={16} />
              <a href="mailto:info@viralcheckmedia.com" className="hover:text-primary transition-colors">
                info@viralcheckmedia.com
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border text-center text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Viral Check Media. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
